import React from 'react'
import { emailValidate } from '../../utils'

class EditUserEmailPassword extends React.Component {
  state = {
    visible: false,
    email: this.props.email ? this.props.email : '',
    pass: '',
    pass2: ''
  }

  renderInput = ({ fieldName, value, label, secure=false }) => {
    return (
      <div>
        <label>{label}</label>
        <input 
          type={secure ? 'password' : 'text'} 
          className="form-control" 
          placeholder={label} 
          onChange={event=>this.setState({ [fieldName]: event.target.value })}
          defaultValue={value}
        />
      </div>
    )
  }

  btnDisabled() {
    const { email, pass, pass2 } = this.state
    if( !email.length || !pass.length || !pass2.length || pass!==pass2 ) return true
    else if( !emailValidate(email) ) return true
    return false
  }

  renderForm() {
    const { email, pass, pass2 } = this.state
    return (
      <form className="mt-3">
        {this.renderInput({fieldName: 'email', value: email, label: 'Adres email'})}
        {this.renderInput({fieldName: 'pass', value: pass, label: 'Hasło', secure: true})}
        {this.renderInput({fieldName: 'pass2', value: pass2, label: 'Powtórz hasło', secure: true})}
        { pass && pass.length && pass2 && pass2.length && pass!==pass2 ? <div className="alert alert-danger small">Podane hasła nie są identyczne</div> : null}
        { pass && pass.length<6 && pass2 && pass2.length<6 ? <div className="alert alert-danger small">Hasło musi mieć min. 6 znaków</div> : null}
        { email.length>3 && !emailValidate(email) ? <div className="alert alert-danger small">Adres email jest niepoprawny</div> : null}
      
        <button
          className="btn btn-primary mt-2"
          disabled={ this.btnDisabled() }
          onClick={ () => this.props.updateUserEmailPassword(email, pass) }
        >Edytuj email lub hasło
        </button>
      </form>
    )
  }



  render() {
    if( this.state.visible ) return this.renderForm()
    else return (
      <div>
        <div className="alert alert-info small my-3">Ze względów bezpieczeństwa, zmianę loginu/hasła należy potwierdzieć oddzielnie</div>
        <button
          className="btn btn-primary mt-2"
          onClick={ () => this.setState({ visible: true }) }
        >Edytuj email lub hasło
        </button>
      </div>
    )
  }
}

export default EditUserEmailPassword


// WEBPACK FOOTER //
// ./src/screens/ManageUsers/EditUserEmailPassword.js